// extracted by mini-css-extract-plugin
export var alertIcon = "_u0-0";